import { z } from 'zod';

export const format = z.enum(['Hyper', 'Super', 'City', 'Contact']);
export type Format = z.infer<typeof format>;

export const AVAILABLE_LANGUAGES = ['en', 'fr', 'es'] as const;

export type AvailableLanguagesType = (typeof AVAILABLE_LANGUAGES)[number];

export type InternalOptions = {
  startDate: Date;
  endDate: Date;
};

/**
 * Barcode type representing the structure of a barcode.
 */
export type Barcode = {
  code: string;
  formats: BarcodeFormat[];
};

/**
 * Item type representing the structure of each row in the table.
 */
export type InnovationListItem = {
  barcodeWithLabel: string;
  supplierName: string;
  goalProgress: number;
  launchDate: string | Date;
  format: Format;
  possessionRate: number;
  averageWeeklySalesQuantity: number;
  subFamilyAverageWeeklySalesQuantity: number;
  isClickable: boolean;
  isInternal: boolean;
  hasTarget: boolean;
};

export type InnovationListExportItem = {
  barcode: string;
  label: string;
  goalProgress: number;
  launchDate: string;
  format: Format;
  possessionRate: number;
  averageWeeklySalesQuantity: number;
  subFamilyAverageWeeklySalesQuantity: number;
};

/**
 * Barcode format type representing the kpis details.
 */

export const barCodes = z.object({
  averageWeeklySalesAmount: z.number(),
  averageWeeklySalesQuantity: z.number(),
  averageWeeklySalesQuantityGoal: z.number(),
  detentionSalesRate: z.number(),
  format: format,
  launchDate: z.date(),
  scopeStartDate: z.date(),
  salesAmount: z.number(),
  salesAmountWithoutPromo: z.number(),
  salesAmountWithPromo: z.number(),
  salesQuantity: z.number(),
  salesQuantityWithoutPromo: z.number(),
  salesQuantityWithPromo: z.number(),
  subFamily: z.string(),
  subFamilyAverageWeeklySalesAmount: z.number(),
  subFamilyAverageWeeklySalesQuantity: z.number()
});

export type BarcodeFormat = z.infer<typeof barCodes>;
